import { render, staticRenderFns } from "./GermanyFlagSVG.vue?vue&type=template&id=2cd1be47&scoped=true&"
import script from "./GermanyFlagSVG.vue?vue&type=script&lang=js&"
export * from "./GermanyFlagSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd1be47",
  null
  
)

export default component.exports